import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95vh"
          w="100%"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
        >
          <Header />
          <CFView textCenter column center w="100%">
            <CFImage
              w="85%"
              maxWidth="350px"
              src={mobileHeroText}
              alt="Jordan Sushi hero text"
              zIndex={98}
            />
            <CFView mt="40px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) 20% 0% / cover no-repeat`}
          zIndex={90}
          column
        >
          <CFView column justifyStart alignStart ml="2%" h="100%" mt="4%">
            <CFImage
              w="100%"
              maxWidth="900px"
              src={heroText}
              alt="Jordan Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate relative bottom="105px" left="205px" zIndex={98}>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
